<template>
  <div>
    <LittleCard
        v-if="!isLoading"
        variant="danger"
        :text="$t('dashboard.little_cards.equipamentos_inativos')"
        :value="vns.filter(v => !v.status).length"
        icon="power-off"
        class="shadow"
    >
      <template v-slot:top>
        <i class="fas fa-times" @click="$emit('close')"/>
      </template>
    </LittleCard>
    <Loading v-else/>
  </div>
</template>

<script>
import LittleCard from "@/components/LittleCard";
import Loading from "@/components/Loading";
import {mapGetters} from "vuex";

export default {
  name: 'EquipamentsInactive',
  components: {LittleCard, Loading},
  computed: {
    ...mapGetters({
      vns: 'vns/all',
      isLoading: 'vns/isLoading'
    })
  }
}
</script>

<style lang="scss" scoped>
/deep/ .card-body {
  &:hover {
    .top {
      i {
        visibility: visible;
      }
    }
  }

  .top {
    i {
      cursor: pointer;
      margin-top: -1rem;
      margin-right: -1rem;
      float: right;
      visibility: hidden;
    }
  }
}
</style>
